export default "__VITE_ASSET__B32BxNj$__"